<template>
  <v-dialog
    ref="key"
    v-model="modal"
    :return-value.sync="editedDate"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="editedDate"
            readonly
            solo
            style="margin: 5px 10px 0;"
            v-bind="attrs"
            v-on="on"
            hide-details
          />
    </template>
    <v-date-picker v-model="editedDate" scrollable :color="color" :dark="!isLight">
      <v-spacer />
      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.key.save(editedDate)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
  props: {
    k: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      requried: true,
    },
    isLight: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    modal: false,
    editedDate: null,
  }),
  watch: {
    editedDate () {
      this.onChange(this.k, this.editedDate)
    }
  },
}
</script>
